<template>
  <div class="request-window">
    <div class="content">
      <img class="avatar" :src="request.user.image_url || '/default-avatar.png'" alt="Avatar" />

      <h2 class="name">{{ request.user.name || 'Без имени' }}</h2>

      <p class="comment">
        {{ request.comment }}
      </p>

      <div class="actions">
        <button class="decline-button" :disabled="loading" @click="handleDecline">
          {{ loading ? '...' : 'Отклонить' }}
        </button>
        <button class="accept-button" :disabled="loading" @click="handleAccept">
          {{ loading ? '...' : 'Принять' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  request: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['accept', 'decline']);

const loading = ref(false);

function handleAccept() {
  loading.value = true;
  emit('accept', props.request.id);
}

function handleDecline() {
  loading.value = true;
  emit('decline', props.request.id);
}
</script>

<style scoped>

.request-window {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
}

.content {
  max-width: 460px;
  width: 100%;
  text-align: center;
  padding: 24px;
}

.avatar {
  width: 96px;
  height: 96px;
  border-radius: 24px;
  object-fit: cover;
  margin-bottom: 16px;
}

.name {
  font-size: 18px;
  font-family: "Eastman-Bold", sans-serif;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.comment {
  font-size: 15px;
  color: var(--text-secondary);
  font-family: "Eastman-Regular", sans-serif;
  line-height: 1.5;
  margin-bottom: 24px;
  white-space: pre-wrap;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 14px;
}

.decline-button {
  background-color: #ffecec;
  color: #d61f1f;
  border: none;
  padding: 10px 20px;
  border-radius: 999px;
  font-family: "Eastman-Bold", sans-serif;
  font-size: 15px;
  cursor: pointer;
}

.accept-button {
  background-color: #d7eaff;
  color: #2173e5;
  border: none;
  padding: 10px 20px;
  border-radius: 999px;
  font-family: "Eastman-Bold", sans-serif;
  font-size: 15px;
  cursor: pointer;
}

.decline-button:disabled,
.accept-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>